import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProductService } from 'src/app/market-place/services/product.service';
import { environment } from 'src/environments/environment';
import { Media } from '../../login/pages/perfil/interfaces-perfil/interfacesPerfil';
import { BalanceService } from '../../services/balance.service';
import { CartServiceService } from '../../services/cart-service.service';
import { StorageService } from '../../services/storage.service';
import { ToastService } from '../../services/toast.service';
import { PromDatesService } from 'src/app/services/prom-dates.service';

@Component({
  selector: 'app-card-productos',
  templateUrl: './card-productos.component.html',
  styleUrls: ['./card-productos.component.scss'],
})
export class CardProductosComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() idProduct: number;
  @Input() userId: any;
  @Input() storeId: any;
  @Input() imgProduct: Media[] = [];
  @Input() nameProduct: string = '';
  @Input() price: number = 0;
  @Input() pPromo: number = 0;
  @Input() description: string;
  @Input() store: any;
  @Input() user: any;
  @Input() country: string;
  @Input() editing: boolean;
  @Input() presentation: string;
  @Input() promInit: string;
  @Input() promEnd: string;

  url = environment.url;
  urlMarketplace = `/market-place/products`;
  carritoIcon: string = './assets/img/icons/addCarrito.svg';
  irCarritoIcon: string = './assets/img/icons/iracarrito.svg';
  thumbnailImage: string = '';
  total: number = 0;
  cantidad: number = 0;
  contador: number = 0;
  op = '';
  currency: any;
  curDate!: Date;
  dateInit!: Date;
  dateEnd!: Date;
  validProm: boolean = false;
  private balanceObs: Subscription = undefined;

  constructor(
    private router: Router,
    private storageService: StorageService,
    public cartService: CartServiceService,
    private toastService: ToastService,
    private balanceService: BalanceService,
    private productSv: ProductService,
    private dates: PromDatesService
  ) {}

  ngOnInit() {
    this.balanceObs = this.balanceService.currencySource.subscribe((res) => {
      this.currency = res;
    });

    this.curDate = new Date();
    this.transDate();
    if (this.promInit && this.promEnd) {
      if (this.dateInit <= this.curDate && this.dateEnd >= this.curDate) {
        this.validProm = true;
      }
    } else if (this.promInit && !this.promEnd) {
      if (this.dateInit <= this.curDate) {
        this.validProm = true;
      }
    } else if (!this.promInit && this.promEnd) {
      if (this.dateEnd >= this.curDate) {
        this.validProm = true;
      }
    } else {
      this.validProm = false;
    }

    if (this.store) {
      this.store.country = this.country;
    } else if (this.user) {
      this.user.country = this.country;
    }

    if (this.imgProduct[0]) {
      this.thumbnailImage = `${this.url}/file/${this.imgProduct[0].img}`;
    } else {
      this.thumbnailImage = './assets/img/logo/logo-naranja-light.png';
    }
    this.findValue(this.idProduct);
  }

  ngOnDestroy(): void {
    this.balanceObs.unsubscribe();
  }

  ngAfterViewInit(): void {
    setTimeout(async () => {
      const change = await this.balanceService.setCurrency();
      this.currency = change;
    });
  }

  transDate() {
    if (this.promInit && this.promEnd) {
      const splDateInit = this.promInit.split('-');
      const splDateEnd = this.promEnd.split('-');
      this.dateInit = new Date(
        parseInt(splDateInit[0]),
        parseInt(splDateInit[1]) - 1,
        parseInt(splDateInit[2])
      );
      this.dateEnd = new Date(
        parseInt(splDateEnd[0]),
        parseInt(splDateEnd[1]) - 1,
        parseInt(splDateEnd[2])
      );
      this.dateInit.setHours(0o0, 0o0, 0o0, 0o0);
      this.dateEnd.setHours(23, 59, 59, 0);
    } else if (this.promInit && !this.promEnd) {
      const splDateInit = this.promInit.split('-');
      this.dateInit = new Date(
        parseInt(splDateInit[0]),
        parseInt(splDateInit[1]) - 1,
        parseInt(splDateInit[2])
      );
      this.dateInit.setHours(0o0, 0o0, 0o0, 0o0);
    } else if (!this.promInit && this.promEnd) {
      const splDateEnd = this.promEnd.split('-');
      this.dateEnd = new Date(
        parseInt(splDateEnd[0]),
        parseInt(splDateEnd[1]) - 1,
        parseInt(splDateEnd[2])
      );
      this.dateEnd.setHours(23, 59, 59, 0);
    }
  }

  goCart() {
    this.router.navigate(['/market-place/cart']);
  }

  deleteProduct(id) {
    // console.log(id);
  }

  countProducts(op) {
    if (op != 'sum' && this.cantidad === 0) {
      return false;
    }
    this.contador++;

    if (op == 'sum') {
      this.cantidad++;
    } else {
      if (this.cantidad) {
        this.cantidad--;
      }
    }
    this.op = op;

    // const contador = localStorage.getItem('contador');
    // if (contador) {
    //   let newData = Number(contador);
    //   if (op != 'sum') newData--;
    //   else newData++;
    //   localStorage.setItem('contador', String(newData));
    // } else {
    //   localStorage.setItem('contador', '1');
    // }
  }

  async addToCart(
    idProduct: any,
    storeId: any,
    price: number,
    media,
    description,
    store,
    user,
    title
  ) {
    let oldStorage: any = await this.storageService.get('cart');
    let typeProduct = user ? 'user' : 'store';
    const actual = (await this.findProduct(
      oldStorage,
      user ? user.id : store.id,
      typeProduct
    )) ?? {
      store,
      user,
    };
    const existStore = actual[typeProduct];
    if (existStore) {
      if (!existStore.productos) existStore.productos = [];
      const id = existStore.productos.find(
        (cartProduct) => cartProduct.idProduct === idProduct
      );
      if (!id) {
        existStore.productos.push({
          idProduct,
          storeId,
          userId: this?.user?.id,
          cantidad: 0,
          price,
          media,
          description,
          title,
        });
      }
    }
    if (!oldStorage) {
      const objCart = {
        store,
        user,
      };
      await this.storageService.set('cart', [objCart]);
      oldStorage = [objCart];
    }
    // paso 1) Busco el storage del usuario

    // Paso 2) buscar el producto que se esta modificando
    const actualProduct = actual[typeProduct].productos.find(
      (product) => product.idProduct === idProduct
    ); //producto
    actualProduct.price = price;
    if (
      this.cantidad === 0 &&
      actualProduct.cantidad === this.cantidad &&
      (this.op === 'sum' || this.op === 'rest' || !this.op)
    ) {
      return this.toastService.show(
        'Debes agregar o remover un producto antes de continuar'
      );
    } else if (this.cantidad === actualProduct.cantidad) {
      return;
    }
    actualProduct.cantidad = this.cantidad;
    const storeEditing: any = actual[typeProduct];
    const indexEditing = storeEditing.productos.filter(
      (cartPr) => cartPr.idProduct !== idProduct
    );
    actual[typeProduct].productos = [...indexEditing, actualProduct];
    await this.updateStorage(oldStorage, typeProduct, actual);
  }

  async updateStorage(oldStorage, typeProduct, actual) {
    const newStorage = oldStorage.filter((cart) => {
      if (!cart[typeProduct]) return oldStorage;
      return cart[typeProduct].id !== actual[typeProduct].id;
    });
    newStorage.push(actual);
    await this.storageService.set('cart', newStorage);
    if (this.op) {
      this.cartService.setLength(this.contador, this.op);
      this.contador = 0;
    }
    this.toastService.show('SENTENSES.PRODUCTO_AGREGADO_AL_CARRITO');
  }

  findProduct(storage, userId, type) {
    if (!storage) return null;
    return new Promise((resolve, reject) => {
      resolve(
        storage.find((user) => {
          if (!user[type]) {
            return null;
          }
          return user[type].id === userId;
        })
      );
    });
  }

  async findValue(id) {
    const dataCart = await this.storageService.get('cart');
    if (!dataCart) return;
    dataCart.forEach((cart) => {
      for (const key of Object.keys(cart)) {
        if (cart[key]?.productos) {
          const data = cart[key]?.productos.find(
            (savedCart) => savedCart.idProduct === id
          );
          if (data) {
            this.cantidad = data?.cantidad || 0;
            this.contador = 0;
            return;
          }
        }
      }
    });
  }

  async goProduct(idProduct: number) {
    const data = await this.productSv.openModalProduct(
      idProduct,
      this.editing,
      this.nameProduct
    );
    // if(data >= 0){
    //   this.cantidad = data;
    // }
  }
}
